import { CrossIcon } from '@ui/kit/icons';
import { inTableCheckboxInput } from '@utils/component-framework';
import { useOpgavekompleksetEntry } from '../../../../state/hook.entry.js';
import { useUpdateInputMutation } from '../../../../state/mutations/update-input.js';
import { useInputState } from '../../hook.use-input-state.js';
import { StateBox } from '../atom.state-box/_state-box.js';
import { stateBox, stateBoxContent, icon, button } from './input.checkbox.style.js';
import { jsx } from 'react/jsx-runtime';

function InTableCheckboxInput(props) {
  const update = useUpdateInputMutation();
  const inputEntry = useOpgavekompleksetEntry({
    select: entry => inTableCheckboxInput.entry.asType(entry?.data.tasks[props.taskEntryKey]?.details[props.input.id])
  });
  const onChange = () => {
    update(props.taskEntryKey, props.input.id, {
      type: "in-table-checkbox",
      checked: !inputEntry?.checked
    });
  };
  const state = useInputState(props.input, inputEntry);
  if (state !== "input") {
    const boxState = state === "incorrect" && props.input.validation.shouldBeChecked ? "should-have" : state;
    return /*#__PURE__*/jsx(StateBox, {
      className: stateBox,
      state: boxState,
      textTheme: "colored",
      children: /*#__PURE__*/jsx("div", {
        className: stateBoxContent,
        "data-checked": inputEntry?.checked,
        "data-state": boxState,
        children: /*#__PURE__*/jsx(CrossIcon, {
          className: icon,
          strokeWidth: 0.75
        })
      })
    });
  }
  return /*#__PURE__*/jsx("button", {
    className: button,
    "data-checked": inputEntry?.checked,
    "data-state": state,
    onClick: onChange,
    children: /*#__PURE__*/jsx(CrossIcon, {
      className: icon,
      strokeWidth: 0.75
    })
  });
}

export { InTableCheckboxInput };
//# sourceMappingURL=input.checkbox.js.map
